import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import withContent from '../../../containers/withContent';
import pageContent from '../Payment/payment.content';
import { getPayment } from '../../states/selectors';
import { makePayment } from '../../states/actions';
import { goToPage, pages } from '../../../states/page/actions';

const mapState = (state) => ({
	payment: getPayment(state),
});

const mapDispatch = (dispatch) => ({
	makePayment: () => dispatch(makePayment),
	goToSubmitted: () => dispatch(goToPage(pages.RetailSubmitted)),
});

class Review extends React.Component {
	constructor(props) {
		super(props);

		this.handleMakePayment = this.handleMakePayment.bind(this);
	}

	handleMakePayment() {
		const { makePayment, goToSubmitted } = this.props;
		makePayment().then(() => goToSubmitted());
	}

	render() {
		return (
			<div className="c-o-list-payment__card c-o-card c-o-card--muted c-o-card--bordered">
				Payment Review
				<div>
					<Button onClick={this.handleMakePayment}>Make Payment</Button>
				</div>
			</div>
		);
	}
}

Review.propTypes = {
	payment: PropTypes.shape({}),
	makePayment: PropTypes.func,
	goToSubmitted: PropTypes.func,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: pageContent }))(Review);
